export const getTerretNoirFranceData = () => ({
  name: "Terret Noir",
  country: "France",
  description: "Terret Noir est un cépage rouge rare originaire du Languedoc, principalement utilisé dans les assemblages de Châteauneuf-du-Pape et d'autres appellations du sud de la France.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "25 ha", percentage: "1%", description: "Cépage rare, apportant fraîcheur et légèreté" },
    { name: "Languedoc-Roussillon", area: "50 ha", percentage: "1%", description: "Cultivé dans quelques domaines traditionnels" },
    { name: "Côtes du Rhône", area: "15 ha", percentage: "0.5%", description: "Utilisé dans quelques assemblages" },
    { name: "Provence", area: "10 ha", percentage: "0.2%", description: "Utilisé dans certains rosés" },
    { name: "Autres", area: "10 ha", percentage: "0.3%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Languedoc", x: 48, y: 62, color: "#6d2c7a", size: 2 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#8a4a8a", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage tardif, sensible aux maladies, nécessite des sols bien drainés",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    red: "Vins rouges légers avec des notes de fruits rouges frais et une bonne acidité",
    rose: "Rosés frais et aromatiques avec une acidité vive"
  },
  foodPairing: "Viandes blanches, volailles, poissons, cuisine provençale, fromages frais",
  history: "Terret Noir est un cépage ancien du Languedoc, faisant partie de la famille des Terret (Terret Blanc, Terret Gris, Terret Noir). Il était autrefois plus répandu mais a été progressivement remplacé par des cépages plus productifs. Il connaît aujourd'hui un regain d'intérêt pour sa contribution unique aux assemblages."
}); 